export const JOB_OPPORTUNITIES_ROUTES = {
  get: '/hlx/job-responses/opportunities',
};

export const JOB_OPPORTUNITY_STATUS_ROUTES = {
  patch: '/hlx/job-responses/{responseId}/status',
};

export const JOB_MESSAGES_ROUTES = {
  get: '/hlx/job-responses/{responseId}/messages',
  post: '/hlx/job-responses/{responseId}/messages',
};

export const JOB_MESSAGES_READ_ROUTES = {
  patch: '/hlx/job-responses/{responseId}/messages/read',
};
